<!-- *ngIf="isShown" -->
<div class="card gallery-cards card-with-no-padding">
  <div class="card-head pr-0">
    <div class="row w-100 padding-left align-items-center">
      <div class="col-10 pl-1">
        <div class="title font-24 fontSemiBold">{{'restaurant.Photos & Videos' | translate}}</div>
      </div>
      <div class="col-2 text-right pl-auto pr-0" *ngIf="galleryData?.canAdd" (click)="openForm()">
        <button type="button" class="btn btn-with-icon">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

  </div>

  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <ng-container *ngIf="!dataLoading">
    <div *ngIf="galleryData.restaurantGallary.length; else dataEmpty">
      <ul class="nav nav-tabs scrollable-cards" id="gallery-slider" [hidden]="dataLoading"
        (mousedown)="startDragging($event, false)" (mouseup)="stopDragging($event, false)"
        (mouseleave)="stopDragging($event, false)" (mousemove)="moveEvent($event)">

        <lightgallery class="lightgallery d-flex" [settings]="settings">

          <div class="gallery-item" *ngFor="let item of galleryData.restaurantGallary">
            <a class="view-btn"
              *ngIf="item.type == 'Image'"
              [href]="item.filePath">
              <img *ngIf="item.type == 'Image'" class="img-responsive" [src]="item.thumbnail" />
            </a>
            <a class="video-container view-btn"
              *ngIf="item.type == 'Video'"
              attr.data-video="{{videoType(item)}}">
              <!-- <video [src]="item.filePath"></video> -->
              <img class="img-responsive" [src]="item?.thumbnail" />
            </a>
            <div class="actions" *ngIf="item.canDelete">
              <button mat-icon-button  (click)="deleteRecord(item.id)">
                <mat-icon class="delete-icon">delete</mat-icon>
              </button>
            </div>
          </div>

        </lightgallery>
      </ul>
    </div>

    <ng-template #dataEmpty>
      <div class="card-content">
        <empty-state [title]='"content2.There are no photos or videos here" | translate'
          [img]="'/assets/images/icons/floors-empty.svg'"></empty-state>
        <a class="btn-light mt-1" mat-stroked-button (click)="openForm()" *ngIf="galleryData?.canAdd">
          {{'content2.Start Upload Photos and Videos' | translate}}
        </a>
      </div>
    </ng-template>
  </ng-container>
</div>
